"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModeButtonsView = void 0;
var tslib_1 = require("tslib");
var core_1 = require("@material-ui/core");
var react_1 = tslib_1.__importStar(require("react"));
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var utils_1 = require("../../../utils");
var label_menu_1 = require("./label-menu");
var Root = styled_components_1.default.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n"], ["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n"])));
exports.ModeButtonsView = (0, react_1.memo)(function (_a) {
    var modeIcons = _a.modeIcons, selectedModeId = _a.selectedModeId, labels = _a.labels, labelSaturation = _a.labelSaturation, labelLightness = _a.labelLightness, onSelectedModeIdChange = _a.onSelectedModeIdChange, onLabelClick = _a.onLabelClick;
    var _b = tslib_1.__read((0, react_1.useState)(null), 2), anchorEl = _b[0], setAnchorEl = _b[1];
    var _c = tslib_1.__read((0, react_1.useState)(selectedModeId), 2), clickedMode = _c[0], setClickedMode = _c[1];
    var buttonsWithHandler = (0, react_1.useMemo)(function () {
        return modeIcons.map(function (_a) {
            var id = _a.id, tooltipMessage = _a.tooltipMessage, IconComponent = _a.IconComponent, useLabelMenu = _a.useLabelMenu;
            return (0, utils_1.t)(id, tooltipMessage, selectedModeId === id ? (react_1.default.createElement(IconComponent, { style: { color: 'red' } })) : (react_1.default.createElement(IconComponent, null)), function (event) {
                if (useLabelMenu) {
                    setClickedMode(id);
                    setAnchorEl(event.currentTarget); // open menu
                }
                else {
                    onSelectedModeIdChange(id);
                }
            });
        });
    }, [modeIcons, selectedModeId, onSelectedModeIdChange]);
    var onMenuClose = (0, react_1.useCallback)(function (id) {
        if (id !== undefined) {
            onLabelClick(id);
            onSelectedModeIdChange(clickedMode);
        }
        setAnchorEl(null);
    }, [onSelectedModeIdChange, clickedMode, onLabelClick]);
    return (react_1.default.createElement(Root, null,
        buttonsWithHandler.map(function (_a) {
            var _b = tslib_1.__read(_a, 4), id = _b[0], tooltipMessage = _b[1], icon = _b[2], handler = _b[3];
            return (react_1.default.createElement("div", { key: id, title: tooltipMessage },
                react_1.default.createElement(core_1.IconButton, { disableTouchRipple: true, onClick: handler }, icon)));
        }),
        react_1.default.createElement(label_menu_1.LabelMenu, { anchorEl: anchorEl, onMenuClose: onMenuClose, labels: labels, labelLightness: labelLightness, labelSaturation: labelSaturation })));
});
exports.ModeButtonsView.displayName = 'ModeButtonsView';
var templateObject_1;
